<template>
  <div class="price-item dis-table dis-line dis-select-right" :class="{ 'dis-line-last': isLast }">
    <div class="dis-cell"></div>
    <div class="dis-cell">
      <div class="dis-dot"> </div>
    </div>
    <div class="dis-cell">
      <template v-if="isLC && !ifInternational?.()">
        <div v-for="(serviceItem, serviceIndex) in services" :key="serviceItem.serviceId" class="trip-ct-item flex-hl-vc">
          <span class="trip-ct-label flex-hc-vc">{{ serviceIndex + 1 }}程</span>
          <div class="trip-ct-cabin">
            <span class="cabin">{{ serviceItem.cabinCode || '-' }}<span>舱</span></span>
          </div>
        </div>
      </template>
      <div v-else-if="ifInternational?.()" class="flex-hl-vc">
        <div v-for="(serviceItem) in services" :key="serviceItem.serviceId" class="flex-hl-vc">
          <span class="cabin">{{ serviceItem.cabinCode || '-' }}<span>舱</span></span>
        </div>
      </div >
      <div v-else class="flex-hl-vc">
        <span class="cabin">{{ service.cabinCode || '-' }}<span>舱</span></span>
      </div>
    </div>
    <div class="price-item__rule dis-cell rules-cell">
      <rule-list :service="service" :isJJC="isJJC"></rule-list>
    </div>
    <div class="product-item__placeholder dis-cell">
      <span class="tag">{{ service | priceTag(labelPrices, 'name') }}</span>
      <p class="info"> {{ service | priceTag(labelPrices, 'info') }} </p>
    </div>
    <div class="price-item__price dis-cell">
      <div>
        <span class="price normal-price flex-hc-vc flex-v">
          <span class="dis-price-small" v-if="ifInternational?.() && isRoundTrip?.()">往返 ￥<span class="dis-price-normal">{{ service.defaultFare.amount }} </span>起</span>
          <span class="dis-price-small" v-else>￥<span class="dis-price-normal">{{ service.defaultFare.amount }} </span></span>
          <span class="discount dis-price-small" v-if="fare.discount">{{ fare.discount | discount }}</span>
        </span>
      </div>
    </div>
    <div class="price-item__action dis-cell">
      <div class="dis-button">
        <a-button class="price-item-btn price-item-btn--red" @click="onSelectPrice">立即预订</a-button>
      </div>
      <div class="quantity" v-if="!isLC">
        <span v-if="!ifInternational?.() && service.inventory"> {{ service.inventory | getInventory }} </span>
        <span v-if="ifInternational?.() && intMainService.inventory"> {{ intMainService.inventory | getInventory }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { passengerTypeLanguageMap } from '../config'
import Rule from './Rule'

export default {
  components: {
    'rule-list': Rule
  },
  props: {
    price: Object,
    priceIndex: Number,
    isLast: Boolean,
    product: Object,
    labelPrices: Array,
    itinerary: Object,
    isJJC: Boolean,
    isLC: Boolean,
    segment: Object,
    index: Number
  },
  data () {
    return {
      service: {},
      services: [],
      fare: {},
      isOtherRulesReady: false,
      isRulesReady: false,
      passengerTypeLanguageMap: passengerTypeLanguageMap
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    },
    isRoundTrip: {
      value: 'isRoundTrip',
      default: null
    }
  },
  created () {
    const { price } = this
    this.service = price.detail?.services?.[0]
    this.services = price.detail?.services
    this.fare = this.service.fareDetails[0].fares[0]
  },
  computed: {
    intMainService () {
      const { price } = this
      const mainService = price.detail?.services.find(item => item.isMainSegment) ?? {}
      return mainService
    }
  },
  methods: {
    onSelectPrice () {
      const { price, priceIndex } = this
      this.$emit('select', price, this.fare, priceIndex)
    }
    // 不再调用接口获取权益及退改签规则
    // fetchRule (idx) {
    //   const { itinerary, product, segment, index } = this
    //   const service = product.detail.services[0]

    //   request({
    //     method: 'post',
    //     url: '/api/flight/queryRefunds',
    //     data: {
    //       airline: itinerary.orgDsts[0].airlineCode,
    //       bookTime: moment().format('YYYY-MM-DD HH:mm:ss'),
    //       depTime: `${itinerary.orgDsts[0].departureDate} ${itinerary.orgDsts[0].departureTime}`,
    //       refCabinCode: service.refCabinCode,
    //       cabinCode: service.cabinCode,
    //       productCode: service.productCode,
    //       passengerType: 'ADULT',
    //       netFare: service.fareDetails[0].fares[0].amount,
    //       marketFare: service.fareDetails[0].fares[0].amount,
    //       basePrice: product.className === 'business' ? segment.businessPrice : segment.economyPrice
    //     }
    //   }).then(res => {
    //     this.$emit('showRule', index, idx, res)
    //     this.$nextTick(() => {
    //       this.isRulesReady = true
    //     })
    //   }).catch(err => {
    //     console.error(err)
    //     this.$message.error(err.message || '网络异常，请稍后再试')
    //   })
    // },
    // fetchBenefit () {
    //   const { itinerary, flightProductList, segment } = this
    //   const products = []

    //   flightProductList.forEach(product => {
    //     product.detail.services.forEach((service, idx) => {
    //       const orgDst = itinerary.orgDsts[idx]
    //       // 行李权益区分旅客类型
    //       const fares = []
    //       service.fareDetails.forEach(item => {
    //         fares.push({
    //           passengerType: passengerTypeMap[item.fareType],
    //           netFare: service.fareDetails[0].fares[0].amount,
    //           basePrice: product.className === 'business' ? segment.businessPrice : segment.economyPrice
    //         })
    //       })
    //       products.push({
    //         cabinCode: service.cabinCode,
    //         refCabinCode: service.refCabinCode,
    //         productCode: service.productCode,
    //         depCode: orgDst.departureCode,
    //         arrCode: orgDst.arrivalCode,
    //         flightNo: orgDst.flightNo,
    //         flightDate: orgDst.departureDate,
    //         fares: fares
    //       })
    //     })
    //   })

    //   request({
    //     method: 'post',
    //     url: '/api/flight/queryBenefit',
    //     data: {
    //       airlineCode: itinerary.orgDsts[0].airlineCode,
    //       language: 'zh',
    //       products
    //     }
    //   }).then(res => {
    //     const { benefits } = res

    //     flightProductList.forEach(product => {
    //       if (!product.disabled) {
    //         product.detail.services.forEach(service => {
    //           const group = find(benefits, benefit => {
    //             return benefit.cabinCode === service.cabinCode && benefit.productCode === service.productCode
    //           })

    //           if (group) {
    //             service.benefit.benefits.forEach(benefit => {
    //               const _benefit = find(group.benefitDetails, { code: benefit.code })

    //               if (_benefit) {
    //                 benefit.text = _benefit.name || benefit.text
    //                 benefit.description = _benefit.text || benefit.text
    //               } else {
    //                 benefit.disabled = true
    //               }
    //             })
    //           }
    //         })
    //       }
    //     })

    //     this.flightProductList = flightProductList
    //     this.isOtherRulesReady = true
    //   }).catch(err => {
    //     console.error(err)
    //     this.$message.error(err.message || '网络异常，请稍后再试')
    //   })
    // }
  }
}
</script>
